import { render } from "./text-box.vue?vue&type=template&id=f041670a&scoped=true"
import script from "./text-box.vue?vue&type=script&lang=js"
export * from "./text-box.vue?vue&type=script&lang=js"

import "./text-box.vue?vue&type=style&index=0&id=f041670a&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f041670a"]])

export default __exports__